import { render, staticRenderFns } from "./approve-import.vue?vue&type=template&id=44e5fbe0&scoped=true"
import script from "./approve-import.vue?vue&type=script&lang=js"
export * from "./approve-import.vue?vue&type=script&lang=js"
import style0 from "./approve-import.vue?vue&type=style&index=0&id=44e5fbe0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e5fbe0",
  null
  
)

export default component.exports